import React, { useState } from 'react';
import './Dashboard.css';
import Sidebar from '../../components/Sidebar/Sidebar';
import Topbar from '../../components/Topbar/Topbar';
import { LayoutDashboard, FileText, Users, ShoppingBag, BarChart2 } from 'lucide-react';

function Dashboard() {
  const [menuAberto, setMenuAberto] = useState(false);

  return (
    <div className="dashboard-root">
      <Sidebar menuAberto={menuAberto} setMenuAberto={setMenuAberto} />
      <div className="main-content">
        <Topbar 
          setMenuAberto={setMenuAberto} 
          titulo="Dashboard" 
          // botao={<button className="btn-novo">+ Novo Pedido</button>} 
        />
        <div className="conteudo-dashboard">
          {/* Conteúdo da dashboard aqui */}
          {/* <div className="cards-grid">
            <div className="card-info">
              <span className="card-title">Pedidos Hoje</span>
              <span className="card-value">24</span>
            </div>
            <div className="card-info">
              <span className="card-title">Vendas Hoje</span>
              <span className="card-value destaque">R$ 12.450</span>
            </div>
            <div className="card-info">
              <span className="card-title">Clientes</span>
              <span className="card-value">156</span>
            </div>
            <div className="card-info">
              <span className="card-title">Produtos</span>
              <span className="card-value">89</span>
            </div>
          </div> */}
          {/* <div className="box-recentes">
            <h3>Pedidos Recentes</h3>
            <table className="tabela-recentes">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>CLIENTE</th>
                  <th>TOTAL</th>
                  <th>STATUS</th>
                  <th>AÇÕES</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>#001</td>
                  <td>João Silva</td>
                  <td>R$ 450,00</td>
                  <td><span className="status concluido">Concluído</span></td>
                  <td><span className="acao">👁️</span></td>
                </tr>
                <tr>
                  <td>#002</td>
                  <td>Maria Santos</td>
                  <td>R$ 280,00</td>
                  <td><span className="status pendente">Pendente</span></td>
                  <td><span className="acao">👁️</span></td>
                </tr>
              </tbody>
            </table>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default Dashboard; 